//React
import React from "react";
// @flow
import { Error403Page } from "tabler-react";

function Error403(props) {
  return <Error403Page />;
}

export default Error403;
